import { createContext, useContext, type ReactNode } from "react";
import type { CustomerLinkAdapter } from "./customer-link-adapter";

const CustomerLinkAdapterContext = createContext<CustomerLinkAdapter | null>(
  null,
);

/**
 * Makes the link pages' adapter (the customer's quote and order pages by their emailed link) available to the
 * portal's link routes. Separate from `CustomerDataAdapterProvider`: a different API surface (the main API's
 * public token routes, not the signed-in `/customer-api`), see `customer-link-adapter.ts`.
 */
export function CustomerLinkAdapterProvider({
  adapter,
  children,
}: {
  adapter: CustomerLinkAdapter;
  children: ReactNode;
}) {
  return (
    <CustomerLinkAdapterContext.Provider value={adapter}>
      {children}
    </CustomerLinkAdapterContext.Provider>
  );
}

export function useCustomerLinkAdapter(): CustomerLinkAdapter {
  const adapter = useContext(CustomerLinkAdapterContext);
  if (!adapter) {
    throw new Error(
      "useCustomerLinkAdapter must be used within a CustomerLinkAdapterProvider",
    );
  }
  return adapter;
}
